module.exports = __webpack_public_path__ + "img/certificate3.81d66e69.png";